import { markSkipOnCompleteIfOnErrorIsSet, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { Cart, updateCartWithResult } from "@insite/client-framework/Services/CartService";
import {chain, UpdateCart } from '@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder';
import { getSpreedlyFrame } from "@insite/client-framework/Common/Hooks/useSpreedlyFrame";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";

type HandlerType = Parameters<typeof UpdateCart>[0];


replaceInChain(chain, UpdateCart, UpdateCartWithNotes);


async function UpdateCartWithNotes(props: HandlerType) {
    const state = props.getState();
    const { editedCartNotes } = state.pages.checkoutShipping;
    props.apiParameter.cart.notes = typeof editedCartNotes === "undefined" ? props.cartToUpdate.notes : editedCartNotes;

    if(props.cartToUpdate.properties["SelectedWarehouse"] != null){
        props.apiParameter.cart.properties["SelectedWarehouse"]  = props.cartToUpdate.properties["SelectedWarehouse"];
    }
    if(props.cartToUpdate.properties["SelectedWarehouseDesc"] != null){
        props.apiParameter.cart.properties["SelectedWarehouseDesc"]  = props.cartToUpdate.properties["SelectedWarehouseDesc"];
    }

    const result = await updateCartWithResult(props.apiParameter);

    if (result.successful) {
        props.apiResult = result.result;
        handleSuccessfulCartSubmit(props);
    } else {
        if (result.errorMessage.toLowerCase().startsWith("pending")) {
            const threeDsResult = await threeDsPending(result.errorMessage, props);
            if (threeDsResult) {
                return;
            }

            return false;
        }

        handleFailedCartSubmit(result.errorMessage, props);
        return false;
    }
};


export interface UpdateCartApiParameter extends ApiParameter {
    cart: Cart;
}

const handleSuccessfulCartSubmit = (props: any): void => {
    props.dispatch({
        type: "Data/Carts/ResetCart",
        id: props.apiParameter.cart.id,
    });
};

const handleFailedCartSubmit = (errorMessage: string, props: any): void => {
    markSkipOnCompleteIfOnErrorIsSet(props);
    props.parameter.onError?.();
    props.dispatch({
        type: "Pages/CheckoutReviewAndSubmit/FailedToPlaceOrder",
        errorMessage,
    });
};
const threeDsPending = (errorMessage: string, props: any): Promise<boolean> => {
    return new Promise((resolve, _reject) => {
        const result = JSON.parse(errorMessage.substring(7));
        const spreedlyFrame = getSpreedlyFrame();
        if (!spreedlyFrame?.isSpreedly()) {
            return resolve(false);
        }

        spreedlyFrame.startThreeDSLifecycle(
            result.transactionToken,
            // success
            () => {
                // we have to let the spreedly callback actually submit the order, only it has
                // the gateway transaction id and trying to submit it here causes a race condition
                props.apiResult = { cart: { id: result.cartId } };
                handleSuccessfulCartSubmit(props);
                resolve(true);
            },
            // failure
            async () => {
                const apiParameter = {
                    ...props.apiParameter,
                    cart: { ...props.apiParameter.cart, id: result.cartId, status: "Cart" },
                };
                await updateCartWithResult(apiParameter);
                handleFailedCartSubmit(result.message, props);
                resolve(false);
            },
        );
    });
};